import AdminProviderCECModal from './AdminProviderCECModal';

export default AdminProviderCECModal;
